import { getJson } from "../../core/http";

export function fetchDashboardForecast(locale, window = "30d") {
  const params = new URLSearchParams();
  if (locale) params.set("locale", locale);
  if (window) params.set("window", window);
  const qs = params.toString();
  return getJson(`/api/v1/dashboard/forecast${qs ? `?${qs}` : ""}`);
}

export function fetchPlanetaryPositions({ locale, date, birthDate, birthTime, birthPlace, forceRefresh } = {}) {
  const params = new URLSearchParams();
  if (locale) params.set("locale", locale);
  if (date) params.set("date", date);
  if (birthDate) params.set("birth_date", birthDate);
  if (birthTime) params.set("birth_time", birthTime);
  if (birthPlace) params.set("birth_place", birthPlace);
  if (forceRefresh) {
    params.set("force_refresh", "true");
    params.set("_ts", String(Date.now()));
  }
  const qs = params.toString();
  return getJson(`/api/v1/dashboard/planetary_positions${qs ? `?${qs}` : ""}`);
}

export function fetchDailyHoroscope({ locale, date, birthDate, birthTime, birthPlace, forceRefresh } = {}) {
  const params = new URLSearchParams();
  if (locale) params.set("locale", locale);
  if (date) params.set("date", date);
  if (birthDate) params.set("birth_date", birthDate);
  if (birthTime) params.set("birth_time", birthTime);
  if (birthPlace) params.set("birth_place", birthPlace);
  if (forceRefresh) {
    params.set("force_refresh", "true");
    params.set("_ts", String(Date.now()));
  }
  const qs = params.toString();
  return getJson(`/api/v1/dashboard/daily_horoscope${qs ? `?${qs}` : ""}`);
}
